 <app-form-input
 [parentForm]="parentForm"
 [value]="description.objet"

 [label]="step3.getobjet"
 [type]="'text'" [rule]="'required|minSize_5|maxSize_2000'"
 [errorMessage]="{'required':'ctr_107', 'minLength':'ctr_123'}"
 [name]="getUid()+'_SepAtt_objet'">
 </app-form-input>

 <app-type-objCPV  [uid]="getUid()" [parentForm]="parentForm" [cpv]="description.cpv"></app-type-objCPV>
 <app-form-input-error [activeForm]="parentForm" [name]="rg1" [id]="rg1"></app-form-input-error>

 <app-form-input
 [parentForm]="parentForm"
 [disabled]="disabled"

 [value]="description.isLieuExecutionLivraison"
 [label]="step3.getlieuexecutionlivraison"
 [checkboxDestination]="'boolean'"
 [type]="'checkbox'" [rule]="''"
 [name]="getUid()+'_SepAtt_lieuExecutionCB'">
 </app-form-input>

 <span class="d-block">{{ step3.getspan5  | translate }}</span>

 <app-type-lieu *ngIf="!estCbChecked" [uid]="'lieuExecution' + getUid()" [parentForm]="parentForm"
 [disabled]="disabled"
 [rule]="'required'" [errorMessage]="{ 'pattern' : 'ctr_221'}"
 [lieuLivraison]="description.lieuExecution"></app-type-lieu>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

 <app-type-lieu *ngIf="!estCbChecked"  [uid]="'lieuLivraison' + getUid()" [parentForm]="parentForm"
 [disabled]="disabled"
 [lieuLivraison]="description.lieuLivraison"
 [rule]="'required'" [errorMessage]="{ 'pattern' : 'ctr_222'}"></app-type-lieu>
 <app-form-input-error *ngIf="!estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>

 <app-type-lieu *ngIf="estCbChecked" [uid]="'lieuExecutionLivraison' + getUid()" [parentForm]="parentForm"
 [disabled]="disabled"
  [lieuLivraison]="description.lieuExecutionLivraison"
  [rule]="'required'"
  [errorMessage]="{'pattern' : 'ctr_221'}"></app-type-lieu>
  <app-form-input-error *ngIf="estCbChecked" [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>
